import { Injectable } from "@angular/core";
import { AreaAction } from "../classes/flow/AreaActions/AreaAction";

@Injectable({
  providedIn: "root",
})
export class AreaActionService {
  public zipCodeInArea(zipCode: string, areaAction: AreaAction): boolean {
    if (!zipCode || !(zipCode.length > 0)) {
      return false;
    }

    const splittedZip = this.extractZipParts(zipCode.replace(/\s/g, "").toUpperCase());
    const splittedStartZip = this.extractZipParts(areaAction.zipCodeFrom.replace(/\s/g, "").toUpperCase());
    const splittedEndZip = this.extractZipParts(areaAction.zipCodeTo.replace(/\s/g, "").toUpperCase());

    // zipcode number is in between start & end
    if (splittedZip.number > splittedStartZip.number && splittedZip.number < splittedEndZip.number) {
      return true;
    }

    //splittedzip === start
    //check letters
    if (splittedZip.number === splittedStartZip.number) {
      if (splittedZip.firstChar > splittedStartZip.firstChar) {
        return true;
      } else if (splittedZip.firstChar === splittedStartZip.firstChar) {
        if (splittedZip.secondChar >= splittedStartZip.secondChar) {
          return true;
        }
      }
      return false;
    }

    //splittedzip === end
    //check letters
    if (splittedZip.number === splittedEndZip.number) {
      if (splittedZip.firstChar < splittedEndZip.firstChar) {
        return true;
      } else if (splittedZip.firstChar === splittedEndZip.firstChar) {
        if (splittedZip.secondChar <= splittedEndZip.secondChar) {
          return true;
        }
      }
      return false;
    }

    return false;
  }

  private extractZipParts(zipCode: string): { number: number; firstChar: number; secondChar: number } {
    return {
      number: Number(zipCode.slice(0, 4)),
      firstChar: this.alphaToNumber(zipCode[4]),
      secondChar: this.alphaToNumber(zipCode[5]),
    };
  }

  private alphaToNumber(char: string): number {
    return "ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(char.toUpperCase());
  }
}
